import { H1 } from '@payaca/ambrosia';
import { useTranslation } from '@/i18n';
import ServicePlanCustomerReminderControl from '@/ui/components/servicePlanCustomerReminderControl/ServicePlanCustomerReminderControl';
import AuthenticatedPageWrapper from '@/ui/layouts/authenticatedPageWrapper/AuthenticatedPageWrapper';
import { FC } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router';

interface IProps {}

const ServicePlansCustomerReminders: FC = () => {
  const { customerReminderId } = useParams<{ customerReminderId?: string }>();
  const translate = useTranslation();

  const isCreatingReminder = customerReminderId === 'new';

  return (
    <>
      <Helmet title={translate('pages.servicePlanCustomerReminders.title')} />
      <AuthenticatedPageWrapper
        className="service-plan-page"
        breadcrumbItems={[
          { label: 'Back', to: '/service-plans/customer-reminders' },
          { label: 'Customer reminder' },
        ]}
      >
        <div className="px-8 py-4">
          <H1>
            {isCreatingReminder
              ? 'New customer reminder'
              : 'Edit customer reminder'}
          </H1>
        </div>
        <div className="p-4">
          <ServicePlanCustomerReminderControl
            servicePlanCustomerReminderPublicId={
              !isCreatingReminder ? customerReminderId : undefined
            }
          />
        </div>
      </AuthenticatedPageWrapper>
    </>
  );
};

export default ServicePlansCustomerReminders;
